
import HomeInspire from "./HomeInspire";
import HomeValue from "./HomeValue";
import HomeHeritage from "./HomeHeritage";
import HomeChalenge from "./HomeChalenge";
import HomeAdventure from "./HomeAdventure";
import HomeEnroll from "./HomeEnroll";
import HomeVideo from "./HomeVideo";
import HomeBanner from "./HomeBanner";
import HomeClass from "./HomeClass";
import HomeAbout from "./HomeAbout";
import HomeHistory from "./HomeHistory";
import HomeAlumni from "./HomeAlumni";
import HomeDiary from "./HomeDiary";
import EnquiryPopup from "../../component/EnquiryPopup";
import React, { useState } from "react";

export default function Home({initialData}) {
  const [showPopup, setShowPopup] = useState(() => {
    if (typeof window === "undefined") return false;
    return !sessionStorage.getItem("enquiry_popup_closed");
  });

  const handleClose = () => {
    setShowPopup(false);
    if (typeof window !== "undefined") {
      sessionStorage.setItem("enquiry_popup_closed", "true");
    }
  };

  return (
    <>
      <HomeBanner />
      <HomeAbout />
      <HomeInspire />
      <HomeChalenge />
      <HomeHistory />
      <HomeValue />
      <HomeClass />
      <HomeHeritage />
      <HomeAlumni />
      <HomeAdventure />
      <HomeVideo />
      <HomeDiary initialData={initialData?.blogs}/>
      <HomeEnroll initialData={initialData?.branch}/>

      {/* <EnquiryPopup show={showPopup} onHide={handleClose} /> */}
    </>
  )
}
